export enum WorkflowStatus {
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Cancelling = 'CANCELLING',
  Cancelled = 'CANCELED',
  Expired = 'EXPIRED'
}
